<template>
  <div :class="[this.$root.$data.miniprogram ? '' : 'activeRule_top']">
    <common-title titleName="活动规则" :bcColor="'#F7F8FC'" :isAPPShow="true"></common-title>
    <div class="activeRule">
      <div class="rule_text" v-html="ruleText"></div>
    </div>
  </div>
</template>

<script>
import { reqInvitationInfo } from '@/api/invitationCommission';
import { mapState } from 'vuex';

export default {
  data() {
    return {
      ruleText: '',
    };
  },
  computed: {
    ...mapState(['userInfo']),
  },
  mounted() {
    this.getRuleInfo();
  },
  methods: {
    getRuleInfo() {
      reqInvitationInfo().then(res => {
        console.log('res-rule', res);
        const { rule } = res;
        this.ruleText = rule;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.activeRule_top {
  padding-top: 100px;
}

.activeRule {
  padding: 36px;

  ::v-deep p {
    min-height: 40px;
    color: #333;
    font-weight: 400;
    font-size: 22px;
    font-style: normal;
    line-height: 33px;
    text-align: left;
  }

  p:empty {
    min-height: 20px;
  }
}
</style>
